import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Trainer } from './trainer.model';

@Injectable()
export class TrainerService {
    constructor(private http: HttpClient) {}

    findAll(): Observable<Trainer[]> {
        return this.http.get<Trainer[]>('/api/trainers', {});
    }

    search(keyword: string): Observable<Trainer[]> {
        return this.http.get<Trainer[]>(
            `/api/trainers/search?keyword=${keyword}`
        );
    }

    findById(id): Observable<Trainer> {
        return this.http.get<Trainer>('/api/trainers/' + id);
    }

    update(trainer) {
        return this.http.put('/api/trainers', trainer);
    }

    createSkill(skill, trainerId) {
        return this.http.post(
            '/api/trainers/' + trainerId + '/trainer-skills',
            skill
        );
    }

    deleteSkill(skill, trainerId) {
        return this.http.delete(
            `/api/trainers/${trainerId}/trainer-skills/${skill.id}`
        );
    }

    create(trainer): Observable<any> {
        return this.http.post<any>('/api/trainers', trainer);
    }

    getEvaluations(trainerId): Observable<any[]> {
        return this.http.get<any[]>(
            '/api/trainers/' + trainerId + '/evaluations'
        );
    }

    resetPicture(trainerId) {
        return this.http.delete('/api/trainers/' + trainerId + '/picture');
    }

    uploadPicture(trainerId, file) {
        let formData = new FormData();
        formData.append('file', file);
        return this.http.post(
            '/api/trainers/' + trainerId + '/picture',
            formData
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/trainer/trainer.service.ts